<template>
    <div class="modal_bg" @click="fnEvent(false)"></div>
    <div class="modal_layer">
        <div class="modal_title">
            키워드
            <div class="close_btn" @click="fnEvent(false)">
                <img src="@/assets/common/close.png" alt="" />
            </div>
        </div>

        <div class="modal_content bg">
            <div class="keyword_modal">
                <div class="keyword_add">
                    <button class="monitoring_btn" @click="switchInput(true, $event)"></button>
                    <form class="keyword_form">
                        <div class="input_wrap" v-show="state.isNewKeyword">
                            <input
                                class="new_keyword"
                                ref="keywordRef"
                                type="text"
                                v-model="keyword.newData"
                                @change="addList"
                                @input="checkText()"
                            />
                            <button
                                class="remove_btn"
                                type="button"
                                @mousedown="state.inputBulr = true"
                                @click="switchInput(false, $event)"
                            ></button>
                        </div>
                    </form>
                </div>
                <ul class="keyword_list">
                    <li class="keyword" :class="{ active: value.state }" v-for="(value, idx) in keyword.list">
                        <button class="remove_btn" type="button" @click="changeActive(value.idx)">
                            {{ value.keyword }}
                            <img v-if="!value.state" src="@/assets/board/close_gray.png" @click.stop="removeList(value.idx)" />
                            <img v-else src="@/assets/board/close_wh.png" @click.stop="removeList(value.idx)" />
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <p class="modal_message">설정한 키워드는 매일 19시 이후 자동 X에서 검색합니다.</p>
        <div class="modal_btn full" @click="fnEvent(true)">확인</div>
    </div>
</template>
<script lang="ts">
    import { apiService, onMounted, onUnmounted, reactive, ref, returnCode, watch } from "@/BaseComponent";
    import { nextTick } from "vue";

    export default {
        emits: ["close"],
        setup(props: any, { emit }: any) {
            const { changeCode } = returnCode();
            const state = reactive({
                inputBulr: false,
                isNewKeyword: false as boolean,
            });
            const keywordRef = ref(null) as any;
            const keyword = reactive({
                list: [] as Array<{ idx: number; keyword: string; state: boolean }>,
                newData: "" as string,
            });

            onMounted(() => {
                document.body.style.overflow = "hidden";
                getList();
            });

            onUnmounted(() => {
                document.body.style.overflow = "auto";
            });

            const getList = async () => {
                const res = await apiService.keyword.getList();
                if (res && res.returnCode === 0) {
                    keyword.list = res.list;
                } else {
                    keyword.list = [];
                }
            };

            const addList = async () => {
                if (keyword.newData && !state.inputBulr) {
                    const param = { keyword: keyword.newData };
                    const res = await apiService.keyword.add(param);
                    if (res) {
                        if (res.returnCode === 0) {
                            getList();
                            keyword.newData = "";
                            // switchInput(false);
                        } else if (res.returnCode !== undefined) {
                            alert(changeCode(res.returnCode));
                        }
                    }
                }
            };

            const changeActive = async (idx: number) => {
                const res = await apiService.keyword.updateState(idx);
                if (res) {
                    if (res.returnCode === 0) {
                        getList();
                    } else if (res.returnCode === 32) {
                        alert("최대 10개까지 가능합니다.");
                    } else if (res.returnCode !== undefined) {
                        alert(changeCode(res.returnCode));
                    }
                }
            };

            const removeList = async (idx: number) => {
                const res = await apiService.keyword.remove(idx);
                if (res && res.returnCode === 0) {
                    getList();
                } else {
                    alert(changeCode(res.returnCode));
                }
            };

            const checkText = () => {
                state.inputBulr = false;
                if (keyword.newData.length > 10) keyword.newData = keyword.newData.slice(0, 10);
            };

            const switchInput = (isOpen: boolean, event: Event | null = null) => {
                event?.preventDefault();
                state.inputBulr = false;
                state.isNewKeyword = isOpen;
                keyword.newData = "";
                if (isOpen && keywordRef.value) nextTick(() => keywordRef.value.focus());
            };

            const fnEvent = (result: boolean) => {
                emit("close", result);
            };

            return { props, fnEvent, state, keyword, switchInput, changeActive, addList, keywordRef, checkText, removeList };
        },
    };
</script>
<style scoped>
    .modal_layer {
        max-width: 720px;
    }
    .modal_content.bg {
        width: calc(100% - 80px);
        max-height: 375px;
        padding: 40px;
        align-items: start;
    }
    .modal_content.bg div.keyword_modal {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;
        height: 100%;
    }

    .modal_message {
        width: 100%;
        text-align: center;
        padding: 20px 0;
        color: var(--blueFond);
        font-family: "Neo";
        font-size: 20px;
    }

    .keyword_add {
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 16px;
    }
    .keyword_add .monitoring_btn {
        box-sizing: border-box;
        width: 36px;
        height: 36px;
        border: 2px solid var(--blue);
        background-color: var(--blue);
        background-image: url("../assets/board/monitoring_on.png");
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
    }
    .keyword_form {
        width: calc(100% - 36px);
        height: 36px;
    }
    .input_wrap {
        position: relative;
        display: inline-block;
        max-width: 200px;
    }

    .input_wrap input.new_keyword {
        width: 100%;
        height: 36px;
        padding: 6px calc(10px + 24px) 6px 10px;
        font-size: 16px;
    }

    .input_wrap .remove_btn {
        cursor: pointer;
        width: 24px;
        height: 24px;
        background-color: unset;
        background-image: url("../assets/board/close_gray.png");
    }
    .input_wrap .remove_btn {
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        right: 2%;
        z-index: 3;
    }

    .keyword_modal .keyword_list {
        width: 100%;
        overflow-y: auto;
        max-height: 265px;
    }

    ul.keyword_list {
        display: flex;
        flex-direction: row;
        gap: 16px;
        flex-wrap: wrap;
    }
    ul.keyword_list li.keyword {
        background-color: #dfdfdf;
    }
    ul.keyword_list li.keyword > button {
        padding: 6px 6px 6px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        background-color: unset;
        cursor: pointer;
    }

    ul.keyword_list li.keyword > button > img {
        margin-left: 10px;
    }
    ul.keyword_list li.keyword.active {
        background-color: var(--blue);
    }

    ul.keyword_list li.keyword.active button {
        color: #fff;
    }
</style>
